import {
  exTxIsDisputed,
  exTxIsExpirePayment,
  exTxIsOfferExtendBooking,
  exTxIsRequestPayment,
} from '../../../util/customTransaction/extendRentalTransaction';
import {
  txExtendedBooking,
  txIsAccepted,
  txIsCanceled,
  txIsCreatedPayment,
  txIsDeclined,
  txIsDeclineExtendBooking,
  txIsDeclineOffer,
  txIsDisputed,
  txIsEnquired,
  txIsInitiatePayment,
  txIsOffer,
  txIsOffered,
  txIsOfferExtendBooking,
  txIsPaymentExpired,
  txIsPaymentPending,
  txIsRequested,
  txIsReviewed,
  txIsStartingReview,
  txIsTransferred,
  txRequestBookingExtend,
  txReview,
} from '../../../util/customTransaction/mainRentalTransaction';

export const getBookingStatus = (intl, tx) => {
  if (txIsRequested(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.requested',
      defaultMessage: 'Pending',
    });
  } else if (txIsAccepted(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.accepted',
      defaultMessage: 'Accepted',
    });
  } else if (txIsDeclined(tx) || txIsCanceled(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.decline',
      defaultMessage: 'Declined',
    });
  } else if (txIsTransferred(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.transfered',
      defaultMessage: 'Transfered',
    });
  } else if (txIsInitiatePayment(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.manualPayment',
      defaultMessage: 'Manual payment',
    });
  } else if (txIsCreatedPayment(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.manualPayment',
      defaultMessage: 'Auto create payment',
    });
  } else if (txIsPaymentPending(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.pendingPayment',
      defaultMessage: 'Accepted - Pending payment',
    });
  } else if (txIsEnquired(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.enquired',
      defaultMessage: 'Enquired',
    });
  } else if (txIsPaymentExpired(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.expiredPayment',
      defaultMessage: 'Expired payment',
    });
  } else if (txRequestBookingExtend(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.requestedExtend',
      defaultMessage: 'Requested extend booking',
    });
  } else if (txIsOfferExtendBooking(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.offeredExtend',
      defaultMessage: 'Offered extend',
    });
  } else if (txExtendedBooking(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.extendedBooking',
      defaultMessage: 'Extended booking',
    });
  } else if (txIsDeclineExtendBooking(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.declinedExtendBooking',
      defaultMessage: 'Declined Extended booking',
    });
  } else if (txIsReviewed(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.reviewed',
      defaultMessage: 'Reviewed',
    });
  } else if (txIsStartingReview(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.startingReview',
      defaultMessage: 'Starting review',
    });
  } else if (txIsOffer(tx) || txIsOffered(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.requestedOffer',
      defaultMessage: 'Negotiation requested',
    });
  } else if (txIsDeclineOffer(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.declinedNegotiation',
      defaultMessage: 'Negotiation declined',
    });
  } else if (txIsDisputed(tx)) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.disputed',
      defaultMessage: 'Disputed',
    });
  } else if (exTxIsExpirePayment) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.extendExpiredPayment',
      defaultMessage: 'Extend expired payment',
    });
  } else if (exTxIsRequestPayment) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.extendRequestPayment',
      defaultMessage: 'Extend pending',
    });
  } else if (exTxIsDisputed) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.extendDisputed',
      defaultMessage: 'Extend disputed',
    });
  } else if (exTxIsOfferExtendBooking) {
    return intl.formatMessage({
      id: 'AMTxPage.Summary.status.extendOfferMoreExtend',
      defaultMessage: 'Extend offer extend more',
    });
  } else {
    return intl.formatMessage({ id: 'AMTxPage.Summary.na', defaultMessage: 'N/A' });
  }
};
